import React from "react";
import { Helmet } from 'react-helmet';

class RKGLandingPage extends React.Component {

    render() {

        const styleContent = `
            .lom-box-grau {
                background-color: #F8F9FA;
                padding: 20px 25px 5px;
            }

            .lom-box-h1 {
                background: #009EE3;
                padding: 20px 25px 10px 25px;
                color: #fff;
                margin-bottom: 30px;
            }

            .lom-box-kategorie {
            background: #fff;
            text-align: center;
            box-shadow: 0 5px 15px rgba(0,0,0,.08);
            padding: 15px;
            height: 100%;
            }

            .fake-h2 {
            font-size:  1.375rem;
            line-height: 1.3;
            font-weight: 600;
            }

            .lom-faq-details {
            background: #F8F9FA;
            margin-bottom: 1rem;
            }

            .lom-faq-antwort {
            padding: 1rem 1rem 1px 1rem;
            }


            .lom-faq-summary {
            padding: 1rem;
            background: #009EE3;
            color: #fff;
            cursor: pointer;
            }

            .lom-button-kategorie {
                color: #fff;
                background-color: #009EE3;
                curser: pointer;
                display: inline-block;
                font-weight: 400;
                text-align: center;
                white-space: nowrap;
                vertical-align: middle;
                user-select: none;
                border: 1px solid transparent;
                padding: 0.375rem 0.75rem;
                font-size: 1rem;
                line-height: 1.5;
                transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                width: 100%;
                text-decoration: none;
                text-transform: uppercase;
            }

            .lom-button-kategorie:hover {
                background-color: #1486bd;
            }

            .lom-button-ausrichtung {
            vertical-align:  middle;
            text-align: right;
            }

            .lom-zweispaltig {  display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr;
            gap: 0px 20px;
            grid-auto-flow: row;
            grid-template-areas:
                "lom-zweispaltig-spalte-1 lom-zweispaltig-spalte-2";
            margin-bottom: 30px;
            }

            .lom-zweispaltig-spalte-1 { grid-area: lom-zweispaltig-spalte-1; }
            .lom-zweispaltig-spalte-2 { grid-area: lom-zweispaltig-spalte-2; }

            .lom-vierspaltig {  display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: 1fr;
            gap: 0px 20px;
            grid-auto-flow: row;
            grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2 lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }

            .lom-vierspaltig-spalte-1 { grid-area: lom-vierspaltig-spalte-1; margin-bottom: 20px; }
            .lom-vierspaltig-spalte-2 { grid-area: lom-vierspaltig-spalte-2; margin-bottom: 20px; }
            .lom-vierspaltig-spalte-3 { grid-area: lom-vierspaltig-spalte-3; margin-bottom: 20px; }
            .lom-vierspaltig-spalte-4 { grid-area: lom-vierspaltig-spalte-4; margin-bottom: 20px; }

            @media only screen and (max-width: 640px) {
            .lom-zweispaltig {  display: block;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr;
            gap: 10px 0px;
            grid-auto-flow: row;
            grid-template-areas:
                "lom-zweispaltig-spalte-1 lom-zweispaltig-spalte-2";
            }

            .lom-zweispaltig-spalte-1 { grid-area: lom-zweispaltig-spalte-1; }
            .lom-zweispaltig-spalte-2 { grid-area: lom-zweispaltig-spalte-2; }

            .lom-vierspaltig {  display: block;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: 1fr;
            gap: 10px 0px;
            grid-auto-flow: row;
            grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2 lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }

            .lom-vierspaltig-spalte-1 { grid-area: lom-vierspaltig-spalte-1; }
            .lom-vierspaltig-spalte-2 { grid-area: lom-vierspaltig-spalte-2; }
            .lom-vierspaltig-spalte-3 { grid-area: lom-vierspaltig-spalte-3; }
            .lom-vierspaltig-spalte-4 { grid-area: lom-vierspaltig-spalte-4; }

            .lom-button-ausrichtung {
                vertical-align: middle;
                text-align: left;
            }
            }

            <style>
            @media (max-width: 1240px) {
            .lom-vierspaltig {
                grid-template-columns: 1fr 1fr;
                grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2"
                "lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }
            }
        `;

        return (
            <div className="uk-container">
                <Helmet>
                    <script type="application/ld+json">
                        {`{
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                                {
                                "@type": "Question",
                                "name": "Wie finde ich das richtige Mercedes-Ersatzteil bei RKG?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Am zuverlässigsten finden Sie es per FIN: Wir gleichen Ihre Fahrzeugdaten ab und prüfen die volle Kompatibilität."
                                }
                                },
                                {
                                "@type": "Question",
                                "name": "Sind Original-Mercedes-Ersatzteile besser als Nachbauten?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Ja, dank geprüfter Materialien, exakter Passform und abgestimmter Funktion – das bedeutet Sicherheit und Langlebigkeit."
                                }
                                },
                                {
                                "@type": "Question",
                                "name": "Welche Zahlarten und Versanddienstleister gibt es bei RKG?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Sie wählen zwischen gängigen Karten- und Online-Zahlungen; der Versand erfolgt mit etablierten Dienstleistern."
                                }
                                }
                            ]
                            }`}
                    </script>
                    <style type="text/css">{styleContent}</style>
                </Helmet>
                <img style={{ marginTop: "50px" }} src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-header.jpg" width="1200" alt="Original-Mercedes-Benz Ersatzteile" />
                <div className="lom-box-h1">
                    <h1 style={{ color: "#fff" }}>Original-Mercedes-Benz-Ersatzteile</h1>
                </div>

                <p>Im RKG-Onlineshop finden Sie Original-Mercedes-Benz-Ersatzteile und passgenaues Zubeh&ouml;r f&uuml;r Ihr Fahrzeug &ndash; von der A-Klasse, &uuml;ber C- und E-Klasse, bis hin zu GLC und AMG. Unser Sortiment ist darauf ausgelegt, Sicherheit, Werterhalt und perfekte Passform sicherzustellen, damit Ihr Mercedes so f&auml;hrt, wie er vom Hersteller konzipiert wurde.</p>

                <h2>Entdecken Sie unsere Mercedes-Ersatzteile</h2>

                <div className="lom-vierspaltig">
                    <div className="lom-vierspaltig-spalte-1">
                        <div className="lom-box-kategorie">
                            <h3>Mercedes-Benz <br />Motor-Ersatzteile</h3>
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-motor.jpg" alt="Mercedes-Benz Motor-Ersatzteile" />
                            <p>Geh&auml;use, Filter, K&uuml;hlung uvm.</p>
                            <a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motor">Zur Kategorie</a>
                        </div>
                    </div>
                    <div className="lom-vierspaltig-spalte-2">
                        <div className="lom-box-kategorie">
                            <h3>Mercedes-Benz <br />Getriebe-Ersatzteile</h3>
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-getriebe.jpg" alt="Mercedes-Benz Getriebe-Ersatzteile" />
                            <p>Schalt- &amp; Automatikgetriebe</p>
                            <a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-getriebe">Zur Kategorie</a>
                        </div>
                    </div>
                    <div className="lom-vierspaltig-spalte-3">
                        <div className="lom-box-kategorie">
                            <h3>Mercedes-Benz <br />Fahrzeugbauteile</h3>
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-fahrzeugbauteile.jpg" alt="Mercedes-Benz Fahrzeugbauteile" />
                            <p>Verkleidung, Achse, Bremsen uvm.</p>
                            <a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-fahrzeug">Zur Kategorie</a>
                        </div>
                    </div>
                    <div className="lom-vierspaltig-spalte-4">
                        <div className="lom-box-kategorie">
                            <h3>Mercedes-Benz <br />Öl & Pflegeprodukte</h3>
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-oel-pflege.jpg" alt="Mercedes-Benz Öl & Pflegeprodukte" />
                            <p>Diverse &Ouml;le, Lackstifte &amp; Pflegemittel</p>
                            <a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-oel-pflege">Zur Kategorie</a>
                        </div>
                    </div>
                </div>

                <h2>Beliebte Ersatzteil-Kategorien</h2>

                <div className="lom-vierspaltig">
                    <div className="lom-vierspaltig-spalte-1">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-achse">Achse</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-anbauteile">Anbauteile</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-auspuffanlage">Auspuffanlage</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-bremsanlage">Bremsanlage</a></p>
                    </div>
                    <div className="lom-vierspaltig-spalte-2">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-elektrische-anlage">Elektrische Anlage</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-federn-aufhaengung-hydraulik">Federn, Aufhängung, Hydraulik</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-heizung-lueftung">Heizung & Lüftung</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-kraftstoffversorgung">Kraftstoffversorgung</a></p>
                    </div>
                    <div className="lom-vierspaltig-spalte-3">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-kupplung">Kupplung</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-luftfilter-motoraufladung">Luftfilter & Motoraufladung</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorelektrik-steuergeraete-sensoren">Motorelektrik</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorkuehlung">Motorkühlung</a></p>
                    </div>
                    <div className="lom-vierspaltig-spalte-4">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorschmierung">Motorschmierung</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorsteuerung">Motorsteuerung</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-raeder">Räder</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-scheibenwaschanlage">Scheibenwaschanlage</a></p>
                    </div>
                </div>

                <h2>Ihre Vorteile im RKG-Shop</h2>

                <div className="lom-vierspaltig">
                    <div className="lom-vierspaltig-spalte-1">
                        <div className="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="Icon Check" />
                            <p><strong>Originalqualit&auml;t vom autorisierten Partner</strong></p>
                            <p>RKG steht seit 1927 f&uuml;r Kundenn&auml;he und Expertise &ndash; mit enger Markenpartnerschaft und tiefem Teilewissen.</p>
                        </div>
                    </div>
                    <div className="lom-vierspaltig-spalte-2">
                        <div className="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="Icon Check" />
                            <p><strong>Einfach online bestellen</strong></p>
                            <p>&Uuml;bersichtliche Kategorien, intelligente Suche und pers&ouml;nliche Beratung f&uuml;hren schnell zum richtigen Mercedes-Ersatzteil in unserem Online-Shop-Ergebnis.</p>
                        </div>
                    </div>
                    <div className="lom-vierspaltig-spalte-3">
                        <div className="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="Icon Check" />
                            <p><strong>Schnell und sicher abwickeln</strong></p>
                            <p>Unser Shop bietet deutschlandweiten Versand mit etablierten Dienstleistern, transparente Abwicklung, SSL-gesicherten Checkout mit g&auml;ngigen Zahlarten.</p>
                        </div>
                    </div>
                    <div className="lom-vierspaltig-spalte-4">
                        <div className="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="Icon Check" />
                            <p><strong>Erreichbar &amp; verbindlich</strong></p>
                            <p>Telefonischer Support und Kontaktformular sorgen f&uuml;r kurze Wege &ndash; vom ersten Produktcheck bis zur Auftragsabwicklung.</p>
                        </div>
                    </div>
                </div>

                <h2>Originale Mercedes-Ersatzteile &ndash; streng gepr&uuml;fte Qualit&auml;t</h2>

                <div className="lom-zweispaltig" style={{ marginBottom: "40px" }}>
                    <div className="lom-zweispaltig-spalte-1">
                        <p>Mercedes-Ersatzteile erf&uuml;llen die strengen Herstellervorgaben &ndash; von Materialg&uuml;te, &uuml;ber Ma&szlig;haltigkeit, bis zu Pr&uuml;fkriterien. <strong>Das Ergebnis ist exakte Passgenauigkeit</strong>. Das bedeutet: Montage ohne Improvisation, optimale Funktion und die Gewissheit, dass alle Komponenten exakt aufeinander abgestimmt sind und sicher funktionieren. Im Vergleich zu Nachbauten profitieren Sie von h&ouml;chster Sicherheit, nachhaltiger Langlebigkeit und einem sp&uuml;rbaren Beitrag zum Werterhalt Ihres Fahrzeugs.</p>
                    </div>
                    <div className="lom-zweispaltig-spalte-2">
                        <p>Ob A-Klasse, C-Klasse, E-Klasse, GLC oder AMG: F&uuml;r jedes Modell stehen passende Mercedes-Benz-Teile bereit &ndash; auf dem aktuellen technischen Stand und h&auml;ufig mit Optimierungen gegen&uuml;ber fr&uuml;heren Teilenummern. F&uuml;r Pflege- und Verschlei&szlig;teile lohnt sich proaktives Handeln: rechtzeitig wechseln, Folgesch&auml;den vermeiden, Fahrfreude und Werterhalt sichern.</p>
                    </div>
                </div>

                <div className="lom-zweispaltig">
                    <div className="lom-zweispaltig-spalte-1">
                        <img style={{ marginBottom: "10px" }} src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-werkstatt.jpg" alt="Mercedes-Ersatzteile für Werkstätten" />
                    </div>
                    <div className="lom-zweispaltig-spalte-2">
                        <h2>Verschiedene Fahrzeugbereiche und ihre Ersatzteile</h2>
                        <ul>
                            <li><strong>Motor und Antrieb</strong>: F&uuml;r dauerhafte Performance sind Filter (&Ouml;l, Luft, Kraftstoff) sowie Z&uuml;nd- bzw. Gl&uuml;hkerzen wichtig. Riemen und Spannrollen sollten gem&auml;&szlig; Wartungsintervallen gepr&uuml;ft werden, um Folgesch&auml;den zu vermeiden. Originalteile stellen die erforderlichen Spezifikationen bei Durchfluss, Z&uuml;ndbild und Materialfestigkeit sicher.</li>
                            <li><strong>Bremsanlage</strong>: Bremsscheiben, -bel&auml;ge und Bremsfl&uuml;ssigkeit sind sicherheitsrelevant. Originalkomponenten harmonieren in Reibwert, Temperaturbest&auml;ndigkeit und ABS/ESP-Abstimmung &ndash; f&uuml;r kurze Bremswege und ein reproduzierbares Pedalgef&uuml;hl.</li>
                            <li><strong>Fahrwerk und Lenkung</strong>: Sto&szlig;d&auml;mpfer, Federn, Querlenker und Spurstangen beeinflussen Komfort, Traktion und Pr&auml;zision. Mercedes-Originalteile gew&auml;hrleisten die richtige Kennlinie und Geometrie &ndash; wichtig f&uuml;r Spurtreue, Reifenverschlei&szlig; und Fahrstabilit&auml;t.</li>
                            <li><strong>Elektrik und Beleuchtung</strong>: Batterien, Steuerger&auml;te, Sensoren sowie Scheinwerfer und R&uuml;ckleuchten erfordern exakte Kompatibilit&auml;t. Originalteile sichern korrekte Schnittstellen, Spannungen und &ndash; wo n&ouml;tig &ndash; eine problemlose Codierung.</li>
                            <li><strong>Karosserie</strong>: Au&szlig;enspiegel, Grills, Zierleisten und Scheibenwischer &uuml;berzeugen durch passgenaue Halterungen, Oberfl&auml;chenqualit&auml;t und aerodynamisch optimierte Profile f&uuml;r klare Sicht und geringere Ger&auml;usche.</li>
                            <li><strong>Innenraum und Komfort</strong>: Fu&szlig;matten und Kofferraummatten sch&uuml;tzen den Innenraum dauerhaft; Pflegeprodukte erhalten Materialien und Haptik. Originalzubeh&ouml;r wurde f&uuml;r die jeweiligen Spaltma&szlig;e, Befestigungspunkte und Sicherheitsaspekte konstruiert.</li>
                            <li><strong>&Ouml;le, Pflege und Verschlei&szlig;</strong>: Achten Sie auf die Mercedes-Benz-Freigaben (z. B. f&uuml;r Motor&ouml;le). Reifen und Felgen sollten zur Fahrzeugfreigabe passen. So bleiben Fahrverhalten und Assistenzsysteme zuverl&auml;ssig innerhalb der Spezifikation.</li>
                        </ul>
                    </div>
                </div>

                <div className="lom-box-grau" style={{ marginBottom: "50px" }}>
                    <div className="lom-zweispaltig">
                        <div className="lom-zweispaltig-spalte-1">
                            <h2>So finden Sie das passende Mercedes-Ersatzteil bei RKG</h2>
                            <p><strong>Die einfachste und sicherste Methode ist der FIN/VIN-Check</strong>: Mit der Fahrgestellnummer lassen sich exakt jene Mercedes-Ersatzteile ermitteln, die f&uuml;r Ihr Fahrzeug freigegeben sind &ndash; inklusive Baujahr, Motorisierung und Ausstattungslinien.</p>
                            <p>Ber&uuml;cksichtigen Sie stets Karosserieform, Antrieb und Getriebe, denn schon kleine Unterschiede k&ouml;nnen andere Teile erfordern.</p>
                        </div>
                        <div className="lom-zweispaltig-spalte-2">
                            <p><strong>Sie sind sich nicht sicher, ob das Ersatzteil bei Ihrem Fahrzeug passt? Kein Problem, senden Sie uns die Fahrgestellnummer/FIN-Nummer Ihres Fahrzeugs. Wir pr&uuml;fen f&uuml;r Sie, ob das Teil passt</strong>.</p>
                            <p>Bei elektrischen Komponenten empfiehlt sich der Einbau durch einen Fachbetrieb &ndash; denn teilweise sind hierf&uuml;r Codierungen erforderlich, damit Systeme wie Licht, Assistenz oder Komfortfunktionen fehlerfrei arbeiten.</p>
                        </div>
                    </div>
                </div>


                <div className="lom-zweispaltig">
                    <div className="lom-zweispaltig-spalte-1">
                        <img style={{ marginBottom: "10px" }} src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/mercedes-ersatzteile-werkstatt-2.jpg" alt="Mercedes-Ersatzteile für Werkstätten" />
                    </div>
                    <div className="lom-zweispaltig-spalte-2">
                        <h2>Mercedes-Ersatzteile f&uuml;r Werkst&auml;tten &ndash; bei RKG</h2>
                        <p>F&uuml;r Werkst&auml;tten z&auml;hlt eine verl&auml;ssliche Teileversorgung, damit die Fahrzeug-Hebeb&uuml;hnen nicht stillstehen. Wir unterst&uuml;tzen Sie mit planbaren Lieferoptionen, klaren Verf&uuml;gbarkeitsinformationen und auf Wunsch mit einer FIN-basierten Identifikation, die Fehlbestellungen minimiert.</p>
                        <p>Mercedes-Original-Ersatzteile sind die Grundlage f&uuml;r Gew&auml;hrleistung, dokumentierte Qualit&auml;t und zufriedene Endkunden &ndash; besonders bei sicherheitsrelevanten Baugruppen.</p>
                        <p>Profitieren Sie bei RKG von kurzen Reaktionszeiten, kompetenten Ansprechpartnern und einem gut sortierten Portfolio von Verschlei&szlig; bis Karosserie.</p>
                    </div>
                </div>

                <div className="lom-box-grau">
                    <h2>Bestellablauf &amp; Services rund um RKG-Mercedes-Ersatzteile</h2>
                    <ul>
                        <li><strong>In drei Schritten</strong>: Fahrzeugdaten bzw. FIN bereithalten &rarr; passendes Teil ausw&auml;hlen &rarr; sicher bezahlen und versenden lassen.</li>
                        <li><strong>Versand &amp; Abholung</strong>: schnelle Zustellung deutschlandweit; auf Wunsch beraten wir vor der Bestellung zum optimalen Teile-Setup.</li>
                        <li><strong>R&uuml;ckgabe &amp; Rechtliches</strong>: transparente Regelungen zu Widerruf, AGB und Datenschutz &ndash; klar verlinkt und leicht zug&auml;nglich.</li>
                    </ul>
                </div>

                <p>Verlassen Sie sich auf gepr&uuml;fte Originalqualit&auml;t, kompetente Beratung, schnellen Versand mit etablierten Dienstleistern sowie sichere Zahlarten. So kombinieren Sie die Bequemlichkeit eines modernen Mercedes-Ersatzteile-Online-Shops mit der Expertise eines autorisierten Partners &ndash; transparent, komfortabel und jederzeit erreichbar.</p>
                <p><strong>Jetzt Mercedes-Original-Ersatzteile im RKG-Onlineshop bestellen</strong> &ndash; mit FIN-Check, schneller Lieferung und pers&ouml;nlichem Expertenservice. Halten Sie Ihren Mercedes werthaltig, sicher und zu 100 % original.</p>

                <h2>FAQ &ndash; H&auml;ufige Fragen zu Ersatzteilen von Mercedes-Benz</h2>
                <details className="lom-faq-details">
                    <summary className="lom-faq-summary">
                        <strong>Wie finde ich das richtige Mercedes-Ersatzteil bei RKG?</strong>
                    </summary>
                    <div className="lom-faq-antwort">
                        <p>Am zuverl&auml;ssigsten finden Sie es per FIN: Wir gleichen Ihre Fahrzeugdaten ab und pr&uuml;fen die volle Kompatibilit&auml;t.</p>
                    </div>
                </details>

                <details className="lom-faq-details">
                    <summary className="lom-faq-summary">
                        <strong>Sind Original-Mercedes-Ersatzteile besser als Nachbauten?</strong>
                    </summary>
                    <div className="lom-faq-antwort">
                        <p>Ja, dank gepr&uuml;fter Materialien, exakter Passform und abgestimmter Funktion &ndash; das bedeutet Sicherheit und Langlebigkeit.</p>
                    </div>
                </details>


                <details className="lom-faq-details">
                    <summary className="lom-faq-summary">
                        <strong>Welche Zahlarten und Versanddienstleister gibt es bei RKG?</strong>
                    </summary>
                    <div className="lom-faq-antwort">
                        <p>Sie w&auml;hlen zwischen g&auml;ngigen Karten- und Online-Zahlungen; der Versand erfolgt mit etablierten Dienstleistern.</p>
                    </div>
                </details>

                <h2>Weitere Ersatzteil-Kategorien</h2>

                <div className="lom-vierspaltig">
                    <div className="lom-vierspaltig-spalte-1">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-bremsanlage-bremssattel">Mercedes-Bremssattel</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-bremsanlage-bremsscheiben">Mercedes-Bremsscheiben</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-elektrische-anlage-blinker">Mercedes-Blinker</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-elektrische-anlage-heckleuchten">Mercedes-Heckleuchten</a></p>
                    </div>
                    <div className="lom-vierspaltig-spalte-2">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-heizung-lueftung-innenraumfilter">Mercedes-Innenraumfilter</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-kraftstoffversorgung-kraftstofffilter">Mercedes-Kraftstofffilter</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-luftfilter-motoraufladung-luftfilter">Mercedes-Luftfilter</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-anbauteile-mercedes-stern">Mercedes-Sterne</a></p>
                    </div>
                    <div className="lom-vierspaltig-spalte-3">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-elektrische-anlage-nebelscheinwerfer">Mercedes-Nebelscheinwerfer</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorschmierung-oelfilter">Mercedes-Ölfilter</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-elektrische-anlage-scheinwerfer">Mercedes-Scheinwerfer</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-scheibenwaschanlage-scheibenwischer">Mercedes-Scheibenwischer</a></p>
                    </div>
                    <div className="lom-vierspaltig-spalte-4">
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-achse-querlenker">Mercedes-Querlenker</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorkuehlung-wasserpumpen">Mercedes-Wasserpumpen</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorelektrik-zuendkerzen">Mercedes-Zündkerzen</a></p>
                        <p><a className="lom-button-kategorie" href="https://estore.rkg.de/mercedes-motorelektrik-zuendspulen">Mercedes-Zündspulen</a></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default RKGLandingPage;